<template>
  <div class="container">
    <Tbheader :tipo="tipo + ' - Benefícios'" :novo="novo" :titulo="contentEdit.titulo " :icone="icone" />
    <form class id="feedback-form" @submit="formSubmit" method="post">
      <div class="row">
        <div class="col-9 form-group">
          <label>Título:</label>
          <input
            type="text"
            v-model="contentEdit.titulo"
            name="titulo"
            id="titulo"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-md-3 form-group">
          <label>Ativo:</label>
          <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="ativo"
              :class="{'active': contentEdit.ativo == true}"
            >
              <input type="radio" name="ativo" id="ativo" @change="fnAtiva() " :value="true" autocomplete="off" class="valid" /> Sim
            </label>
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="inativo"
              :class="{'active': contentEdit.ativo == false}"
            >
              <input type="radio" name="ativo" id="inativo"  @change="fnAtiva()"  :value="false" autocomplete="off" class="valid" /> Não
            </label>
          </div>
        </div>
        <div class="col-sm-12">
          <hr />
        </div>
        <div class="col-3 form-group">
          <small>Criado em:</small>
          <small v-if="contentEdit.tsInclusao">
            <b>{{formatData(contentEdit.tsInclusao)}}</b>
          </small>
        </div>
        <div class="col-3 form-group"  >
          <small>Alterado em:</small>
          <small v-if="contentEdit.tsAlteracao">
             <b>{{formatData(contentEdit.tsAlteracao)}}</b>
          </small>
        </div>
        <div class="col-6 text-right">
          <button
            type="button"
            name="cancelar"
            class="btn btn-danger btn-md"
            @click="fnCancela()"
          >Cancelar</button>
          <button
           type="submit"
            name="feedback-form-submit"
            class="btn btn-success ml-3"
          >Gravar</button>
        </div>
      </div>
    </form>
    <div>{{temErro}}</div>
  </div>
</template>

<script>
import Tbheader from "../../_include/_headerTabelas";
import { getData,getSuccess,getError } from "../../../global/utils";

export default {
  props: ["id"],
  data() {
    return {
      novo: true,
      tipo: "",
      icone: "",
      urlApi: "",
      suporteAtivo: true,
      success: false,
      error:null,
      contentEdit: {
        titulo:'',
        ativo: false
      },
    };
  },
  components: { Tbheader },
  methods: {
    fnLimpa(){
      this.contentEdit.titulo = ''
      this.contentEdit.ativo = ''
    },
    fnicone() {
      this.icone = this.novo ? "icon-line2-plus" : "icon-line-edit";
    },
    fnAtiva() {
          this.contentEdit.ativo = !this.contentEdit.ativo
    },
    fnCancela(){
      var completa = this.$route.query.aprovacao == 's' ? '/aprovacao' : '';
      this.$router.push({path: "/paineldegerenciamento/listabeneficios"+completa})
    },
    async formSubmit(e) {
        e.preventDefault();
        const metodo = this.$route.params.id ? 'put' : 'post'
        this.contentEdit.tsAlteracao = this.$route.params.id ? this.$moment().format() : null
        const completaUrl = this.$route.params.id ? "/" + this.$route.params.id : ''
       let data = await this.$http[metodo]("/listabeneficios" + completaUrl,this.contentEdit)
        .then(() =>{
            getSuccess();
            this.fnLimpa();
            this.fnCancela();
        })
       .catch(e => {
        return  e
        }); 
        this.error = data
        

    },
    fnGetError(e){
      getError(e)
    },
    fnIsEdit() {
      if (this.$route.params.id != undefined && this.$route.params.id != "") {
        this.tipo = "Editando";
        this.novo = false;
        this.fnCarregaItems(this.$route.params.id)
      } else {
        this.tipo = "Incluindo";
        this.novo = true;
        this.contentEdit.ativo = false
      }
      this.fnicone();
    },
    formatData(value) {
      return this.$moment(String(value)).format("DD/MM/YYYY HH:MM");
    },
    async fnCarregaItems(valueId) {
      let data = await getData(this.urlApi+"/listabeneficios/"+valueId);
      this.contentEdit = data[0].content;
      this.$vs.loading.close()
    },   
  },
  created() {
    this.fnIsEdit();
  },
  computed: {
    confere: function(){
      return this.fnIsEdit()
    },
    temErro(){
      if (this.error){
         return this.fnGetError(this.error)
      }else{
        return ''
      }
    }
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>

</style>